module.exports = __webpack_public_path__ + "static/media/company-default-logo.abf34d78.svg";